import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import SubCategoryModal from "./SubcategoryModal";

const GET_CAT_API_BASE_URL = "https://mediapi.onlinepharmaque.in/api/v1";

const SubCategoryGet = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [subShowModal, setSubShowModal] = useState(false);

  const [selectedOption, setSelectedOption] = useState("");
  const [subcategoryName, setSubcategoryName] = useState("");

  const [isEditMode, setIsEditMode] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [searchText, setSearchText] = useState("");


  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const res = await fetch(`${GET_CAT_API_BASE_URL}/getsubcategory`);
      const data = await res.json();
      setSubCategories(data.result || []);
    } catch {
      toast.error("Failed to load data");
    }
  };

  const subtoggleModal = () => {
    setSubShowModal(!subShowModal);
    setIsEditMode(false);
    setEditItemId(null);
    setSelectedOption("");
    setSubcategoryName("");
  };

  const handleEdit = (item) => {
    setEditItemId(item._id);
    setSelectedOption(item.mainCategoryName);
    setSubcategoryName(item.SubCateoryName);
    setIsEditMode(true);
    setSubShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${GET_CAT_API_BASE_URL}/deletesubcategory/${id}`, {
        method: "DELETE",
      });
      toast.success("Deleted successfully");
      fetchSubCategories();
    } catch {
      toast.error("Delete failed");
    }
  };

  const searchSubCategory = async (text) => {
  try {
    if (!text) {
      fetchSubCategories();
      return;
    }

    const res = await fetch(
      `${GET_CAT_API_BASE_URL}/searchsubcategory?SubCateoryName=${text}`
    );
    const data = await res.json();

    if (data.success) {
      setSubCategories(data.result);
    } else {
      setSubCategories([]);
    }
  } catch (error) {
    toast.error("Search failed");
  }
};


  return (
    <div className="p-6 text-white">

      {/* ===== Header Card (same as image) ===== */}
      <div className="bg-[#1F2A40] rounded-xl px-6 py-5 flex justify-between items-center mb-6">
        <div>
          <h2 className="text-xl font-semibold">SubCategory Management</h2>
          <p className="text-sm text-green-400">
            Create, update & manage subcategories
          </p>
        </div>

        <button
          onClick={subtoggleModal}
          className="flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 px-4 py-2 rounded-lg text-sm font-semibold"
        >
          <FaPlus /> Add SubCategory
        </button>
      </div>

      {/* ===== Search ===== */}
      <div className="mb-4">
       <input
  type="text"
  placeholder="Search subcategory..."
  value={searchText}
  onChange={(e) => {
    setSearchText(e.target.value);
    searchSubCategory(e.target.value);
  }}
  className="w-72 px-4 py-2 rounded-md bg-[#141B2D] border border-gray-700 text-sm outline-none focus:border-indigo-500"
/>

      </div>

      {/* ===== Table ===== */}
      <div className="bg-[#1F2A40] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#3E4396]">
            <tr>
              <th className="px-5 py-3 text-left">#</th>
              <th className="px-5 py-3 text-left">Category Name</th>
              <th className="px-5 py-3 text-left">SubCategory Name</th>
              <th className="px-5 py-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {subCategories.map((el, i) => (
              <tr
                key={el._id}
                className="border-b border-gray-700 hover:bg-[#2A344D] transition"
              >
                <td className="px-5 py-3">{i + 1}</td>

                <td className="px-5 py-3 text-green-400 font-medium">
                  {el.mainCategoryName}
                </td>

                <td className="px-5 py-3 text-green-400 font-medium">
                  {el.SubCateoryName}
                </td>

                <td className="px-5 py-3">
                  <div className="flex justify-center gap-5">
                    <FaEdit
                      onClick={() => handleEdit(el)}
                      className="text-green-500 cursor-pointer"
                      size={16}
                    />
                    <FaTrash
                      onClick={() => handleDelete(el._id)}
                      className="text-red-500 cursor-pointer"
                      size={16}
                    />
                  </div>
                </td>
              </tr>
            ))}

            {subCategories.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-6 text-gray-400">
                  No subcategories found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Modal ===== */}
      {subShowModal && (
        <SubCategoryModal
          isOpen={subShowModal}
          subtoggleModal={subtoggleModal}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          subcategoryName={subcategoryName}
          setSubcategoryName={setSubcategoryName}
          isEditMode={isEditMode}
          editItemId={editItemId}
          subCategories={subCategories}
          onReloadData={fetchSubCategories}
        />
      )}
    </div>
  );
};

export default SubCategoryGet;
